/**
 * Frozen minimum logic (Dawn)
 *
 * Requirements:
 * - Your add-to-cart <form data-type="add-to-cart-form"> must include:
 *   data-is-frozen="true" for frozen_min tagged products, otherwise "false"
 *
 * This script:
 * - Computes frozen one-time subtotal from /cart.js
 * - Injects a top-of-page banner when frozen subtotal < $145
 *
 * NOTE:
 * - We NO LONGER persist debug values into cart attributes because ShipStation
 *   is importing them into order notes. (Those were: frozen_min_applies, etc.)
 *
 * UPDATE:
 * - Exclude bundled items (any cart item with properties._bundleId) from ALL minimum calculations.
 */

(function () {
  var FROZEN_MIN_CENTS = 14500;
  var SUB_MIN_CENTS = 14500;

  var BANNER_ID = 'liw-cart-min-banner';
  var evalTimer = null;
  var lastAttrsKey = null;

  // IMPORTANT: keep this false to avoid ShipStation notes pollution
  var PERSIST_MIN_DEBUG_ATTRIBUTES = false;

  // Keys we used to store. We now clear them (once) and stop writing them.
  var MIN_DEBUG_ATTR_KEYS = [
    'frozen_variant_ids',
    'frozen_min_applies',
    'frozen_subtotal_cents',
    'frozen_min_remaining_cents',
    'sub_min_applies',
    'sub_subtotal_cents',
    'sub_min_remaining_cents'
  ];

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((cents || 0) / 100);
  }

  function ensureBanner() {
    var el = document.getElementById(BANNER_ID);

    // Create once
    if (!el) {
      el = document.createElement('div');
      el.id = BANNER_ID;

      //   el.style.padding = '10px 12px';
      el.style.fontSize = '14px';
      el.style.color = ' #ffffff ';
      el.style.fontWeight = 'normal';
      el.style.textAlign = 'left';
      //   el.style.background = '#fff3cd';
      //   el.style.borderBottom = '1px solid #ffeeba';
      el.style.display = 'none';
    }

    // Always (re)attach it right after the cart drawer footer if possible
    var footer = document.querySelector('div.cart-drawer__footer');
    if (footer) {
      if (footer.nextElementSibling !== el) {
        footer.insertAdjacentElement('afterend', el);
      }
    }

    return el;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function setCartAttributes(attrs) {
    // Disabled on purpose to prevent ShipStation from seeing these in order notes
    if (!PERSIST_MIN_DEBUG_ATTRIBUTES) return Promise.resolve(null);

    var keys = Object.keys(attrs).sort();
    var keyStr = keys.map(function (k) { return k + '=' + String(attrs[k]); }).join('&');

    if (keyStr === lastAttrsKey) return Promise.resolve(null);
    lastAttrsKey = keyStr;

    var params = new URLSearchParams();
    keys.forEach(function (k) {
      params.append('attributes[' + k + ']', String(attrs[k]));
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: params.toString(),
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json();
    });
  }

  function clearMinDebugAttributesOnce() {
    // If we never persisted, nothing to clear. But you already had carts with these set.
    // Clear once per browser to prevent these keys from flowing into checkout/order notes.
    try {
      var storageKey = '__liw_min_debug_attrs_cleared_v1';
      if (window.localStorage && localStorage.getItem(storageKey) === '1') return;

      var params = new URLSearchParams();
      MIN_DEBUG_ATTR_KEYS.forEach(function (k) {
        params.append('attributes[' + k + ']', '');
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: params.toString(),
        credentials: 'same-origin'
      }).then(function () {
        try {
          if (window.localStorage) localStorage.setItem(storageKey, '1');
        } catch (e) {}
      });
    } catch (e) {}
  }

  // Exclude bundled items (any item with properties._bundleId)
  function itemIsBundle(item) {
    try {
      return !!(item && item.properties && item.properties._bundleId);
    } catch (e) {
      return false;
    }
  }

  // Frozen = one-time items where product_type is "Frozen"
  function isFrozenOneTimeItem(item) {
    if (!item) return false;
    if (itemIsBundle(item)) return false; // EXCLUDE bundles
    if (item.selling_plan_allocation) return false; // do NOT count subscriptions toward frozen min
    return String(item.product_type || '').toLowerCase() === 'frozen';
  }

  // Subscription = any item with selling_plan_allocation
  function isSubscriptionItem(item) {
    if (!item) return false;
    if (itemIsBundle(item)) return false; // EXCLUDE bundles
    return !!item.selling_plan_allocation;
  }

  function scheduleEval(delayMs) {
    clearTimeout(evalTimer);
    evalTimer = setTimeout(evaluateMins, typeof delayMs === 'number' ? delayMs : 250);
  }


    // External trigger: document.body.dispatchEvent(new Event('check_cart_minimums'))
  (function bindExternalMinCheckTrigger() {
    if (window.__liw_min_trigger_bound) return;
    window.__liw_min_trigger_bound = true;

    function onTrigger() {
      // run same logic as page load/cart updates
      scheduleEval(0);
    }

    if (document.body) {
      document.body.addEventListener('check_cart_minimums', onTrigger);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        document.body.addEventListener('check_cart_minimums', onTrigger);
      });
    }
  })();


  (function observeCartDrawerFooter() {
    var observer = null;
    var lastFooterEl = null;

    function reattachIfFooterChanged() {
      var footer = document.querySelector('div.cart-drawer__footer');
      if (!footer) return;

      if (footer !== lastFooterEl) {
        lastFooterEl = footer;
        requestAnimationFrame(function () {
          scheduleEval(0);
        });
      }
    }

    function start() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      if (observer) observer.disconnect();

      observer = new MutationObserver(function () {
        reattachIfFooterChanged();
      });

      observer.observe(drawer, { childList: true, subtree: true });
      reattachIfFooterChanged();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  function evaluateMins() {
    return getCart()
      .then(function (cart) {
        var banner = document.getElementById(BANNER_ID);
        if (banner && banner.parentNode) {
          banner.parentNode.removeChild(banner);
        }

        var frozenSubtotal = 0;
        var hasFrozen = false;

        var subSubtotal = 0;
        var hasSub = false;

        (cart.items || []).forEach(function (item) {
          // Bundle items count toward BOTH subtotals, but do NOT trigger a minimum by themselves
          if (itemIsBundle(item)) {
            frozenSubtotal += item.final_line_price;
            subSubtotal += item.final_line_price;
            return;
          }

          if (isFrozenOneTimeItem(item)) {
            hasFrozen = true; // Only real frozen items trigger the minimum
            frozenSubtotal += item.final_line_price;
          }

          if (isSubscriptionItem(item)) {
            hasSub = true; // Only real subscription items trigger the minimum
            subSubtotal += item.final_line_price;
          }
        });

        var frozenRemaining = 0;
        var subRemaining = 0;

        // If there are subscription items in the cart, the SUB minimum takes priority.
        // Frozen minimum is waived in that case (since the sub requirement is also $145).
        if (hasSub) {
          if (subSubtotal < SUB_MIN_CENTS) {
            subRemaining = SUB_MIN_CENTS - subSubtotal;
          }
        } else {
          // Frozen minimum only triggers if there is at least one real frozen item,
          // but bundle dollars can help satisfy it.
          if (hasFrozen && frozenSubtotal < FROZEN_MIN_CENTS) {
            frozenRemaining = FROZEN_MIN_CENTS - frozenSubtotal;
          }
        }

        var parts = [];

        if (hasFrozen && frozenRemaining > 0) {
          parts.push(
            '<div style="margin:0; padding:10px 12px; background-color: #E2725B; margin-bottom:1rem; border-bottom:1px solid #E2725B">' +
              '<strong>Frozen seafood ships with care.</strong> <br />' +
              '$145 minimum in frozen items · <strong>' +
              money(frozenRemaining) +
              '</strong> to go' +
            '</div>'
          );
        }

        if (hasSub && subRemaining > 0) {
          parts.push(
            '<div style="margin:0; padding:10px 12px; background-color: #E2725B; margin-bottom:1rem; border-bottom:1px solid #E2725B">' +
              '<strong>Subscriptions start at $145 per delivery.</strong> <br />' +
              'Build your box · <strong>' +
              money(subRemaining) +
              '</strong> to go' +
            '</div>'
          );
        }

        if (parts.length) {
          // Choose the label based on which minimum is unmet
          var label = '';

          if (frozenRemaining > 0 && subRemaining > 0) {
            label = 'Complete minimums to check out';
          } else if (frozenRemaining > 0) {
            label = 'Add ' + money(frozenRemaining) + ' more in frozen items';
          } else if (subRemaining > 0) {
            label = 'Add ' + money(subRemaining) + ' more in subscription items';
          }

          document.body.classList.add('lummi-min-spend-blocked');
          disableCheckout(label);
        } else {

          document.body.classList.remove('lummi-min-spend-blocked');
          enableCheckout();
        }

        // Do NOT persist these anymore (ShipStation imports them into notes)
        return setCartAttributes({
          frozen_min_applies: !hasSub && hasFrozen && frozenRemaining > 0 ? 1 : 0,
          frozen_subtotal_cents: frozenSubtotal,
          frozen_min_remaining_cents: frozenRemaining,

          sub_min_applies: hasSub && subRemaining > 0 ? 1 : 0,
          sub_subtotal_cents: subSubtotal,
          sub_min_remaining_cents: subRemaining
        });
      })
      .catch(function () {
        var banner = document.getElementById(BANNER_ID);
        if (banner && banner.parentNode) {
          banner.parentNode.removeChild(banner);
        }
      });
  }


  // Run once on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      clearMinDebugAttributesOnce();
      scheduleEval(0);
    });
  } else {
    clearMinDebugAttributesOnce();
    scheduleEval(0);
  }

  // Hook Dawn's cart pub/sub (deterministic)
  (function hookDawnCartPubSub() {
    if (window.__liw_cart_pubsub_hooked) return;
    window.__liw_cart_pubsub_hooked = true;

    try {
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          scheduleEval(0);
        });
      }
    } catch (e) {}
  })();

  function getCheckoutButton() {
    return document.getElementById('CartDrawer-Checkout') ||
      document.querySelector('.cart-drawer__footer button[name="checkout"]');
  }

  function disableCheckout(label) {
    var btn = getCheckoutButton();
    if (!btn) return;

    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent.trim();
    }

    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.style.pointerEvents = 'none';

    if (label) {
      btn.dataset.blockedText = label;
      btn.textContent = label;
    }
}

  function enableCheckout() {
    // Do NOT re-enable checkout if another script (ship date requirement) is blocking it.
    if (document.body && document.body.classList.contains('lummi-shipdate-blocked')) {
      console.log( document.body.classList);
      return;
    }

    var btn = getCheckoutButton();
    if (!btn) return;

    btn.disabled = false;
    btn.removeAttribute('aria-disabled');

    if (btn.dataset.originalText) {
      btn.textContent = btn.dataset.originalText;
      delete btn.dataset.originalText;
    }
  }

})();

// Cart drawer: redirect checkout button to cart when enabled.
(function () {
  function onCartDrawerCheckoutClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var btn = target.closest('#CartDrawer-Checkout');
    if (!btn) return;

    if (
      btn.disabled ||
      btn.getAttribute('aria-disabled') === 'true' ||
      btn.classList.contains('is-disabled-by-ship-week') ||
      document.documentElement.classList.contains('lf-cartdrawer-shipdate-blocked') ||
      document.body.classList.contains('ej-checkout-disabled')
    ) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var scaSpinner = document.getElementById('sca-spinner-checkout');
      if (scaSpinner) {
        scaSpinner.remove();
        if (btn.dataset.blockedText) {
          btn.textContent = btn.dataset.blockedText;
        }
      }



      
      return false;
      return;
    }

    e.preventDefault();
    window.location.href = '/cart';
  }

  document.addEventListener('click', onCartDrawerCheckoutClick, true);
})();











/**
 * Frozen minimum logic (Dawn) FOR INSTANT PAY METHODS
 */
(function () {
  'use strict';

  var EJ_MINIMUM = 145;
  var EJ_DISABLED_CLASS = 'ej-pay-disabled';
  var EJ_NOTICE_CLASS = 'ej-disabled-notice';

  function ejInjectStylesOnce() {
    if (document.getElementById('ej-pay-disable-styles')) return;

    var style = document.createElement('style');
    style.id = 'ej-pay-disable-styles';
    style.textContent =
      '.' + EJ_DISABLED_CLASS + ' { pointer-events: none !important; }' +
      '.' + EJ_NOTICE_CLASS + ' { margin: 10px 0; padding: 10px 12px; font-size: 14px; font-weight: 600; text-align: center; border: 1px solid #ddd; border-radius: 8px; }';
    document.head.appendChild(style);
  }

  function ejGetNumericPrice(sectionEl) {
    var priceWrap = sectionEl.querySelector('[id^="price-"][role="status"]');
    if (!priceWrap) return null;

    var candidates = priceWrap.querySelectorAll(
      '.price-item--sale.price-item--last, .price-item--regular'
    );
    if (!candidates.length) return null;

    var priceEl = Array.prototype.find.call(candidates, function (el) {
      return el.offsetParent !== null && el.textContent.trim() !== '';
    }) || candidates[0];

    var price = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(price) ? null : price;
  }

  function ejGetPurchaseType(sectionEl) {
    if (!sectionEl) return 'regular';

    // Source of truth: product form selling_plan input
    var sellingPlanInput = sectionEl.querySelector('form[action="/cart/add"] input[name="selling_plan"]');

    if (sellingPlanInput) {
      var val = String(sellingPlanInput.value || '').trim();
      if (val) {
        return 'subscription';
      }
      return 'regular';
    }

    // Fallback only if the input is not present
    var selected = sectionEl.querySelector(
      '.loop-w-btn-group-purchase-option.loop-w-btn-group-purchase-option-selected'
    );

    if (!selected) return 'regular';

    if (selected.classList.contains('loop-w-btn-group-purchase-option-onetime')) {
      return 'regular';
    }

    return 'subscription';
  }

  function ejGetProductType(sectionEl) {
    try {
      var productIdInput = sectionEl.querySelector('input[name="product-id"]');
      if (!productIdInput) return null;

      var productId = String(productIdInput.value || '').trim();
      if (!productId) return null;

      if (window.LOOP_WIDGET && window.LOOP_WIDGET[productId] && window.LOOP_WIDGET[productId].product) {
        var t = window.LOOP_WIDGET[productId].product.type;
        return typeof t === 'string' ? t.trim() : null;
      }
    } catch (e) {}

    return null;
  }

  function ejIsFrozen(sectionEl) {
    var t = ejGetProductType(sectionEl);
    return !!(t && t.toLowerCase() === 'frozen');
  }

  function ejSetPaymentAreaState(sectionEl, shouldDisable, disableMessage = "") {
    ejInjectStylesOnce();

    var buttonsWrap = sectionEl.querySelector('.product-form__buttons');
    if (!buttonsWrap) return;

    var spb = buttonsWrap.querySelector('.shopify-payment-button');
    if (!spb) return;

    var existingNotice = buttonsWrap.querySelector('.' + EJ_NOTICE_CLASS);

    if (shouldDisable) {
      spb.classList.add(EJ_DISABLED_CLASS);

      if (existingNotice) {
        var notices = buttonsWrap.querySelectorAll('.' + EJ_NOTICE_CLASS);
        for (var i = 0; i < notices.length; i++) {
          notices[i].parentNode.removeChild(notices[i]);
        }
      }

      var notice = document.createElement('div');
      notice.className = EJ_NOTICE_CLASS;
      notice.innerHTML = disableMessage;
      buttonsWrap.insertBefore(notice, spb);

    } else {
      spb.classList.remove(EJ_DISABLED_CLASS);

      if (existingNotice) {
        existingNotice.remove();
      }
    }
  }

  function ejGetVariantPrice(sectionEl) {
    if (!sectionEl) return null;

    var form = sectionEl.querySelector('form[action="/cart/add"]');
    if (!form) return null;

    var idInput = form.querySelector('input[name="id"].product-variant-id, input[name="id"]');
    if (!idInput || !idInput.value) return null;

    var variantId = parseInt(idInput.value, 10);
    if (!variantId) return null;

    var jsonEl = form.querySelector('script.js-variants-json[type="application/json"]');
    if (!jsonEl || !jsonEl.textContent) return null;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }

    if (!Array.isArray(variants)) return null;

    var variant = variants.find(function (v) {
      return parseInt(v.id, 10) === variantId;
    });

    if (!variant || typeof variant.price !== 'number') return null;

    return variant.price / 100;
  }

  function ejGetLoopSelectedPrice(sectionEl) {
    if (!sectionEl) return null;

    var selected = sectionEl.querySelector(
      '.loop-w-btn-group-purchase-option.loop-w-btn-group-purchase-option-selected'
    );
    if (!selected) return null;

    var priceEl = selected.querySelector('.loop-w-btn-group-purchase-option-price');
    if (!priceEl) return null;

    var price = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(price) ? null : price;
  }

  function ejGetNumericPrice(sectionEl) {
    var priceWrap = sectionEl.querySelector('[id^="price-"][role="status"]');
    if (!priceWrap) return null;

    var candidates = priceWrap.querySelectorAll(
      '.price-item--sale.price-item--last, .price-item--regular'
    );
    if (!candidates.length) return null;

    var priceEl = Array.prototype.find.call(candidates, function (el) {
      return el.offsetParent !== null && el.textContent.trim() !== '';
    }) || candidates[0];

    var price = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(price) ? null : price;
  }

  function ejEvaluateAndApply(sectionEl, qty) {
    if (!sectionEl) return;

    var purchaseType = ejGetPurchaseType(sectionEl);
    var frozen = ejIsFrozen(sectionEl);

    var shouldEnforceMinimum = frozen || purchaseType === 'subscription';

    var price = null;

    if (purchaseType === 'subscription') {
      price = ejGetLoopSelectedPrice(sectionEl);
    }

    if (price === null) {
      price = ejGetVariantPrice(sectionEl);
    }

    if (price === null) {
      price = ejGetNumericPrice(sectionEl);
    }

    if (price === null) return;

    var total = price * qty;
    var meetsMin = total >= EJ_MINIMUM;

    var message = '';

    if (shouldEnforceMinimum) {
      var remaining = Math.max(0, EJ_MINIMUM - total).toFixed(2);

      if (!meetsMin) {
        message = (purchaseType === 'subscription')
          ? 'Subscription Instant Payment Method Notice. Add $' + remaining + ' more to meet the minimum.'
          : 'Frozen Instant Payment Method Notice. Add $' + remaining + ' more to meet the minimum.';
      }

      ejSetPaymentAreaState(sectionEl, !meetsMin, message);
    } else {
      ejSetPaymentAreaState(sectionEl, false);
    }
  }

  function ejGetQtyFromSection(sectionEl) {
    var input = sectionEl.querySelector('.price-per-item__container input.quantity__input[name="quantity"]');
    if (!input) return null;

    var qty = parseInt(input.value, 10) || 0;
    return qty > 0 ? qty : null;
  }

  function ejEvaluateAndApplyWithSettle(sectionEl) {
    if (!sectionEl) return;

    function ejRunOnce() {
      var qtyInput = sectionEl.querySelector('.price-per-item__container input.quantity__input[name="quantity"]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 0) : 0;
      if (qty <= 0) return;

      ejEvaluateAndApply(sectionEl, qty);
    }

    ejRunOnce();

    window.clearTimeout(window.ej_loop_settle_timer_1);
    window.clearTimeout(window.ej_loop_settle_timer_2);
    window.clearTimeout(window.ej_loop_settle_timer_3);

    window.ej_loop_settle_timer_1 = window.setTimeout(ejRunOnce, 50);
    window.ej_loop_settle_timer_2 = window.setTimeout(ejRunOnce, 200);
    window.ej_loop_settle_timer_3 = window.setTimeout(ejRunOnce, 600);
  }

  function ejOnQtyChange(e) {
    if (!e || !e.target) return;

    var section = (e.target.closest && e.target.closest('section[id^="ProductInfo-"]')) || document.querySelector('section[id^="ProductInfo-"]');
    if (!section) return;

    if (
      e.target.matches('input.quantity__input[name="quantity"]') ||
      e.target.closest('.price-per-item__container') ||
      e.target.closest('variant-selects') ||
      e.target.closest('.loop-w-btn-group-purchase-options-container') ||
      e.target.closest('.loop-w-btn-group-purchase-option')
    ) {
      ejEvaluateAndApplyWithSettle(section);
    }
  }

  function ejRunOnLoad() {
    var section = document.querySelector('section[id^="ProductInfo-"]');
    if (!section) return;

    var qty = ejGetQtyFromSection(section);
    if (!qty) return;

    ejEvaluateAndApply(section, qty);
  }

  document.addEventListener('input', ejOnQtyChange, true);
  document.addEventListener('change', ejOnQtyChange, true);
  document.addEventListener('click', ejOnQtyChange, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ejRunOnLoad);
  } else {
    ejRunOnLoad();
  }
})();


(function () {
  var DEBUG = false; // set false when done

  if (!DEBUG) return;

  function logEvent(name) {
    return function (e) {
      console.log('[CART EVENT]', name, {
        type: e.type,
        target: e.target,
        detail: e.detail
      });
    };
  }

  var eventsToWatch = [
    'DOMContentLoaded',
    'shopify:section:load',
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'cart:build',
    'cart-drawer:opened',
    'cart-drawer:updated',
    'cart-drawer:refresh',
    'ajax:complete',
    'ajax:success'
  ];

  eventsToWatch.forEach(function (evt) {
    document.addEventListener(evt, logEvent(evt), true);
  });

  (function interceptFetch() {
    var origFetch = window.fetch;
    window.fetch = function () {
      try {
        var url = arguments[0];
        var urlStr = typeof url === 'string' ? url : (url && url.url) ? url.url : '';
        if (urlStr && urlStr.indexOf('/cart/') !== -1) {
          console.log('[FETCH cart]', urlStr, arguments[1] || {});
        }
      } catch (err) {}
      return origFetch.apply(this, arguments);
    };
  })();

  (function interceptXHR() {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (url && String(url).indexOf('/cart/') !== -1) {
          console.log('[XHR cart]', method, url);
        }
      } catch (err) {}
      return origOpen.apply(this, arguments);
    };
  })();

  console.log('[CART DEBUG] logger enabled');
})();


/**
 * CART PAGE: enforce minimums + show notices above checkout buttons
 * Also disables:
 * - Main checkout button
 * - Accelerated checkout area (Google Pay, etc) by disabling the wrapper
 *
 * Trigger: runs when Dawn removes .cart__items--disabled (cart update finished)
 *
 * NOTE: Add CSS:
 * body.ej-checkout-disabled .cart__blocks { cursor: not-allowed; }
 * body.ej-checkout-disabled .cart__blocks * { cursor: not-allowed !important; }
 */
(function () {
  if (!(document.body && (document.body.classList.contains('template-cart') || window.location.pathname === '/cart'))) return;

  if (window.__ejCartMinObserverInstalled) return;
  window.__ejCartMinObserverInstalled = true;

  var FROZEN_MIN_CENTS = 14500;
  var SUB_MIN_CENTS = 14500;

  var BANNER_ID = 'liw-cart-page-min-banner';

  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
  }

  function blockClick(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // Exclude bundled items (any item with properties._bundleId)
  function itemIsBundle(item) {
    try {
      return !!(item && item.properties && item.properties._bundleId);
    } catch (e) {
      return false;
    }
  }

  function ensureBannerPlacement() {
    var el = document.getElementById(BANNER_ID);

    if (!el) {
      el = document.createElement('div');
      el.id = BANNER_ID;
      el.style.fontSize = '14px';
      el.style.color = '#ffffff';
      el.style.fontWeight = 'normal';
      el.style.textAlign = 'left';
      el.style.display = 'none';
    }

    // After .js-contents and before .cart__ctas
    var cartFooter = document.querySelector('.cart__footer');
    if (cartFooter) {
      var ctas = cartFooter.querySelector('.cart__ctas');

      if (ctas && ctas.parentNode) {
        if (el.parentNode !== ctas.parentNode) {
          ctas.parentNode.insertBefore(el, ctas);
        } else {
          if (el.nextSibling !== ctas) {
            ctas.parentNode.insertBefore(el, ctas);
          }
        }
        return el;
      }
    }

    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (main) {
      if (el.parentNode !== main) main.insertBefore(el, main.firstChild);
      return el;
    }

    return el;
  }

  function getCheckoutButton() {
    return (
      document.querySelector('button#checkout.cart__checkout-button') ||
      document.querySelector('form[action="/cart"] button[name="checkout"]') ||
      document.querySelector('button.cart__checkout-button') ||
      document.getElementById('checkout')
    );
  }

  function getCheckoutLink() {
    return document.querySelector('.cart__ctas a[href^="/checkout"], a[href="/checkout"], a[href^="/checkout"]');
  }

  function getAcceleratedCheckoutWrapper() {
    return document.querySelector('.cart__dynamic-checkout-buttons');
  }

  function disableAcceleratedCheckoutWrapper(wrapper) {
    if (!wrapper) return;

    if (!wrapper.dataset.ejWasDisabled) wrapper.dataset.ejWasDisabled = '1';

    wrapper.style.pointerEvents = 'auto';
    //wrapper.style.opacity = '0.55';
    wrapper.setAttribute('aria-disabled', 'true');

    wrapper.addEventListener('click', blockClick, true);
  }

  function enableAcceleratedCheckoutWrapper(wrapper) {
    if (!wrapper) return;

    if (wrapper.dataset.ejWasDisabled) {
      wrapper.style.pointerEvents = '';
      wrapper.style.opacity = '';
      wrapper.removeAttribute('aria-disabled');
      delete wrapper.dataset.ejWasDisabled;

      wrapper.removeEventListener('click', blockClick, true);
    }
  }

  function disableCheckout(label) {
    var checkoutBtn = getCheckoutButton();
    var checkoutLink = getCheckoutLink();
    var accelWrap = getAcceleratedCheckoutWrapper();

    if (checkoutBtn) {
      if (!checkoutBtn.dataset.originalText) {
        checkoutBtn.dataset.originalText = (checkoutBtn.textContent || '').trim();
      }
      checkoutBtn.disabled = true;
      checkoutBtn.setAttribute('aria-disabled', 'true');
      //checkoutBtn.style.cursor = 'not-allowed';

      if (label) checkoutBtn.textContent = label;
    }

    if (checkoutLink) {
      if (!checkoutLink.dataset.originalText) {
        checkoutLink.dataset.originalText = (checkoutLink.textContent || '').trim();
      }
      checkoutLink.setAttribute('aria-disabled', 'true');
      checkoutLink.style.pointerEvents = 'none';
      //checkoutLink.style.opacity = '0.55';
      //checkoutLink.style.cursor = 'not-allowed';

      if (label) checkoutLink.textContent = label;
    }

    disableAcceleratedCheckoutWrapper(accelWrap);

    document.body.classList.add('ej-checkout-disabled');
  }

  function enableCheckout() {
     if (document.body && document.body.classList.contains('lummi-shipdate-blocked')) {
      console.log( document.body.classList);
      return;
    }
    var checkoutBtn = getCheckoutButton();
    var checkoutLink = getCheckoutLink();
    var accelWrap = getAcceleratedCheckoutWrapper();

    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.removeAttribute('aria-disabled');
      checkoutBtn.style.cursor = '';

      if (checkoutBtn.dataset.originalText) {
        checkoutBtn.textContent = checkoutBtn.dataset.originalText;
        delete checkoutBtn.dataset.originalText;
      }
    }

    if (checkoutLink) {
      checkoutLink.removeAttribute('aria-disabled');
      checkoutLink.style.pointerEvents = '';
      checkoutLink.style.opacity = '';
      checkoutLink.style.cursor = '';

      if (checkoutLink.dataset.originalText) {
        checkoutLink.textContent = checkoutLink.dataset.originalText;
        delete checkoutLink.dataset.originalText;
      }
    }

    enableAcceleratedCheckoutWrapper(accelWrap);

    document.body.classList.remove('ej-checkout-disabled');
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function isFrozenOneTimeItem(item) {
    if (!item) return false;
    if (itemIsBundle(item)) return false; // EXCLUDE bundles
    if (item.selling_plan_allocation) return false;
    return String(item.product_type || '').toLowerCase() === 'frozen';
  }

  function isSubscriptionItem(item) {
    if (!item) return false;
    if (itemIsBundle(item)) return false; // EXCLUDE bundles
    return !!item.selling_plan_allocation;
  }

  var runTimer = null;

  function runNow() {
    clearTimeout(runTimer);

    runTimer = setTimeout(function () {
      evaluate();

      setTimeout(function () {
        evaluate();
      }, 250);
    }, 80);
  }

  function evaluate() {
    return getCart()
      .then(function (cart) {
        var banner = document.getElementById(BANNER_ID);
        if (banner && banner.parentNode) {
          banner.parentNode.removeChild(banner);
        }

        var frozenSubtotal = 0, hasFrozen = false;
        var subSubtotal = 0, hasSub = false;

        (cart.items || []).forEach(function (item) {
          // Bundle items count toward BOTH subtotals, but do NOT trigger a minimum by themselves
          if (itemIsBundle(item)) {
            frozenSubtotal += item.final_line_price;
            subSubtotal += item.final_line_price;
            return;
          }

          if (isFrozenOneTimeItem(item)) {
            hasFrozen = true; // Only real frozen items trigger the minimum
            frozenSubtotal += item.final_line_price;
          }

          if (isSubscriptionItem(item)) {
            hasSub = true; // Only real subscription items trigger the minimum
            subSubtotal += item.final_line_price;
          }
        });

        var frozenRemaining = 0;
        var subRemaining = 0;

        // If there are subscription items in the cart, the SUB minimum takes priority.
        // Frozen minimum is waived in that case (since the sub requirement is also $145).
        if (hasSub) {
          subRemaining = (subSubtotal < SUB_MIN_CENTS) ? (SUB_MIN_CENTS - subSubtotal) : 0;
        } else {
          // Frozen minimum only triggers if there is at least one real frozen item,
          // but bundle dollars can help satisfy it.
          frozenRemaining = (hasFrozen && frozenSubtotal < FROZEN_MIN_CENTS)
            ? (FROZEN_MIN_CENTS - frozenSubtotal)
            : 0;
        }

        var parts = [];

        if (hasFrozen && frozenRemaining > 0) {
          parts.push(
            '<div style="margin:0; padding:10px 12px; background-color:#E2725B; margin-bottom:1rem; border-bottom:1px solid #E2725B">' +
              '<strong>Frozen seafood ships with care.</strong> <br />' +
              '$145 minimum in frozen items · <strong>' + money(frozenRemaining) + '</strong> to go' +
            '</div>'
          );
        }

        if (hasSub && subRemaining > 0) {
          parts.push(
            '<div style="margin:0; padding:10px 12px; background-color:#E2725B; margin-bottom:1rem; border-bottom:1px solid #E2725B">' +
              '<strong>Subscriptions start at $145 per delivery.</strong> <br />' +
              'Build your box · <strong>' + money(subRemaining) + '</strong> to go' +
            '</div>'
          );
        }

        if (parts.length) {
          var label = '';
          if (frozenRemaining > 0) label = 'Add ' + money(frozenRemaining) + ' more in frozen items';
          else if (subRemaining > 0) label = 'Add ' + money(subRemaining) + ' more in subscription items';
          else label = 'Complete minimums to check out';
          
          document.body.classList.add('lummi-min-spend-blocked');
          disableCheckout(label);
        } else {
          document.body.classList.remove('lummi-min-spend-blocked');
          enableCheckout();
        }
      })
      .catch(function () {
        var banner = document.getElementById(BANNER_ID);
        if (banner) banner.style.display = 'none';
        enableCheckout();
      });
  }


  // External trigger: document.body.dispatchEvent(new Event('check_cart_minimums'))
  (function bindExternalMinCheckTrigger() {
    if (window.__ej_cart_min_trigger_bound) return;
    window.__ej_cart_min_trigger_bound = true;

    function onTrigger() {
      // run same logic as initial load/cart updates
      runNow();
    }

    if (document.body) {
      document.body.addEventListener('check_cart_minimums', onTrigger);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        document.body.addEventListener('check_cart_minimums', onTrigger);
      });
    }
  })();



  (function watchCartItemsDisabled() {
    var itemsEl = document.querySelector('.cart__items');
    if (!itemsEl) {
      runNow();
      return;
    }

    var hadDisabled = itemsEl.classList.contains('cart__items--disabled');

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type !== 'attributes') continue;
        if (mutations[i].attributeName !== 'class') continue;

        var hasDisabled = itemsEl.classList.contains('cart__items--disabled');

        if (hadDisabled && !hasDisabled) {
          runNow();
        }

        hadDisabled = hasDisabled;
      }
    });

    obs.observe(itemsEl, { attributes: true, attributeFilter: ['class'] });

    runNow();
  })();

  
})();
